import { useContext } from 'react';
import { Box, Card } from '@mui/material';
import { WindowSizeContext } from '../context/WindowSizeProvider';

export default function LoginFormWrapper({ wrapperSX, children })
{
  const { smallScreen } = useContext(WindowSizeContext);


  return !smallScreen ? <Box sx={wrapperSX ?? { minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Card elevation={0}
        sx={{ width: { md: 420, lg: 480 }, borderRadius: 3, px: { md: 5, lg: 7 }, py: { md: 6, lg: 8 }, backgroundColor: "rgba(255, 255, 255, 0.8)", border: "none", }}>
        {children}
      </Card>
  </Box> : <Box sx={{ mt: 2 }}>{children}</Box>;
}
